var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},[_c('v-row',{attrs:{"justify":"center"}},[_c('video',{ref:"video",attrs:{"width":_vm.width,"height":_vm.height,"src":_vm.source,"autoplay":_vm.autoplay,"playsinline":_vm.playsinline}})]),_c('v-row',{staticClass:"my-4",attrs:{"justify":"center"}},[_c('v-btn',{on:{"click":_vm.onCapture}},[_vm._v(" Ta bild ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }